// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60dffd7c","453":"3920eacb","455":"155ac3cb","857":"0a0c6dad"}[chunkId] + ".chunk.js";
};